// Don't use this component. Use app-components. This is only kept to support the old Header Drawer.

/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-footer-nav-deprecated.html";

/**
 * <p>The ns-footer-nav makes it easy to lay out an JSON object representing navigation
 * as a column list of navigation items.</p>
 *
 * <h2>UX/Design Docs</h2>
 * <p>No UX/Design docs at this time</p>
 *
 * <h1>Footer Nav</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <div style="background-color: var(--color-interactive-8); padding:10px;">
 *       <ns-footer-nav></ns-footer-nav>
 *     </div>
 *   </template>
 * </demo-snippet>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *      ### Styling
 *
 *      ##### `<ns-expressive-link>` does not provide any custom styling at this time.
 *
 *      ### Slots
 *
 *      ##### `<ns-expressive-link>` does not provide any slots at this time
 *
 *  </script>
 * </marked-element>
 *
 */
export class NsFooterNavDeprecated extends PolymerElement {
  static get is() {
    return "ns-footer-nav-deprecated";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * An array of navigation objects. Each object should contain: title and
       * links (an array of objects that contain href and name)
       */
      navigation: {
        type: Array,
        value: [
          {
            title: "about",
            links: [
              { href: "www.google.com", name: "Our Leaders" },
              { href: "www.google.com", name: "Management" },
              { href: "www.google.com", name: "Company" },
              { href: "www.google.com", name: "Careers" }
            ]
          },
          {
            title: "community",
            links: [
              { href: "www.google.com", name: "Nourish the Children" },
              { href: "www.google.com", name: "Force for Good" },
              { href: "www.google.com", name: "Social Responsibility" },
              { href: "www.google.com", name: "Get Involved" }
            ]
          },
          {
            title: "join our team",
            links: [
              { href: "www.google.com", name: "Why Nu Skin" },
              { href: "www.google.com", name: "Financial Rewards" }
            ]
          },
          {
            title: "contact",
            links: [
              { href: "www.google.com", name: "Help" },
              { href: "www.google.com", name: "Contact Information" },
              { href: "www.google.com", name: "Online Live Support" }
            ]
          }
        ]
      },
      /**
       * Locks the element in a desktop or mobile orientation. Options are: blank (default),
       * all (a vertically condensed version), none (a mobile version as an accordion)
       */
      expandbreakpoint: String
    };
  }

  /**
   * Sets all the mobile accordion items to inactive (closed) when connected
   */
  connected() {
    for (let i in this.navigation)
      this.set("navigation." + i + ".active", "inactive");
  }

  /**
   * Toggle the accordion items when in mobile view
   * @param {*} e an event object
   */
  toggleContainer(e) {
    let model = e.model;
    if (model.item.active === "active") {
      model.set("item.active", "inactive");
    } else {
      let delay = 0;
      for (let i in this.navigation) {
        if (this.navigation[i].active === "active") {
          this.set("navigation." + i + ".active", "inactive");
          delay += 500;
        }
      }
      setTimeout(function() {
        model.set("item.active", "active");
      }, delay);
    }
  }
}

customElements.define(NsFooterNavDeprecated.is, NsFooterNavDeprecated);
